export default __webpack_public_path__ + "static/media/loading-img.3bfb08ee.png";